module.exports = __webpack_public_path__ + "static/media/blocks.87c4a31e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/tilemaps/tiles/blocks.png
// module id = 2338
// module chunks = 0